import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import axiosClient from '../axiosClient';
import '../../i18n';

const LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'German' },
  { value: 'es', label: 'Spanish' },
  { value: 'fr', label: 'French' },
  { value: 'it', label: 'Italian' },
  { value: 'nl', label: 'Dutch' },
  { value: 'ja', label: 'Japanese' },
  { value: 'zh-CN', label: 'Chinese' },
  { value: 'pt', label: 'Portuguese' },
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(
    () => localStorage.getItem('zonstaff_language') || 'en'
  );

  useEffect(() => {
    const saved = localStorage.getItem('zonstaff_language');
    if (saved && saved !== i18n.language) {
      i18n.changeLanguage(saved);
      setLanguage(saved);
    }
  }, [i18n]);

  const handleChange = (event) => {
    const lng = event.target.value;
    i18n.changeLanguage(lng);
    setLanguage(lng);
    localStorage.setItem('zonstaff_language', lng);
    axiosClient.post('/update_language', { language: lng }).catch(() => {
      // Error handled silently
    });
  };

  return (
    <label className="language-selector">
      <Globe size={16} aria-hidden="true" />
      <select
        className="language-select"
        value={language}
        onChange={handleChange}
        aria-label="Select language"
      >
        {LANGUAGES.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
    </label>
  );
};

export default LanguageSelector;
